import { render, staticRenderFns } from "./AdjustmentProduct.vue?vue&type=template&id=1126b237&"
import script from "./AdjustmentProduct.vue?vue&type=script&lang=js&"
export * from "./AdjustmentProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports